import React from "react";
import {Descriptions, Table} from "antd";
import {useFullVoc} from "../hooks/voc.hook";
import {defaultSorter} from "../utils/antdhelper/AntdHelper";

const columns = [

    {
        title: 'Код',
        dataIndex: 'ID',
        key: 'ID',
    },
    {
        title: 'Наименование',
        dataIndex: 'NAME',
        key: 'NAME',
    },
    {
        title: 'Всего записей в КР',
        dataIndex: 'hasКR',
        key: 'hasКR',
    },
    {
        title: 'Всего записей в КР из ВИМИС',
        dataIndex: 'hasКRVimis',
        key: 'hasКRVimis',
    },
    {
        title: 'Полные структурированные МКР',
        dataIndex: 'hasКRFull',
        key: 'hasКRFull',
    },
].map(column => ({...column, sorter: defaultSorter(column)}))

const AdminPage = () => {
    const Top = useFullVoc('RG-1').filter(d => d.ID.slice(0, 1) == 'C').map(
        item => ({
            ...item,
            hasКR: item.ID.slice(0, 3) == 'C50' ? 2: 0,
            hasКRVimis: 0,
            hasКRFull: 0
        })
    )

    const summ = (field) => (a, b) => {
        return a + b[field]
    }

    const Total       = Top.length
    const TotalMR     = Top.filter(d => d.hasКR).length
    const TotalMR_Cnt = Top.filter(d => d.hasКR).reduce(summ('hasКR'), 0)
    const TotalVIMIS  = Top.filter(d => d.hasКRVimis).length
    const TotalVIMIS_Cnt  = Top.filter(d => d.hasКRVimis).reduce(summ('hasКRVimis'), 0)
    const TotalFull   = Top.filter(d => d.hasКRVimis).length

    return (<div>
    <Table columns={columns} dataSource={Top} rowKey="CD" data title={ () => "Сведения о доступности клинреков в структурированном виде"}
    />
        <Descriptions title={"Обобщенные сведения"} bordered style={{  padding: '10px' }}>
            <Descriptions.Item label={"Всего нозологических кодов"} span={3}>{Total}</Descriptions.Item>
            <Descriptions.Item label={"Всего с КР"} span={1}>{TotalMR}</Descriptions.Item>
            <Descriptions.Item label={"Всего записей КР"} span={1}>{TotalMR_Cnt}</Descriptions.Item>
            <Descriptions.Item label={"Всего с КР, %"}>{Total > 0 ? (TotalMR/Total * 100.0).toFixed(1): 0}%</Descriptions.Item>
            <Descriptions.Item label={"Всего в КР из ВИМИС"}>{TotalVIMIS}</Descriptions.Item>
            <Descriptions.Item label={"Всего записей в КР из ВИМИС"}>{TotalVIMIS_Cnt}</Descriptions.Item>
            <Descriptions.Item label={"Всего записей в КР из ВИМИС, %"}>{Total > 0 ? (TotalVIMIS/Total * 100.0).toFixed(1): 0}%</Descriptions.Item>
            <Descriptions.Item label={"Всего полных КР"} span={2}>{TotalFull}</Descriptions.Item>
            <Descriptions.Item label={"Всего полных КР, %"} span={1}>{Total > 0 ? (TotalFull/Total * 100.0).toFixed(1): 0}%</Descriptions.Item>

        </Descriptions>

</div>)}

export default AdminPage